import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';

import { IoInsightComponent } from './io-insight.component';

@NgModule({
  declarations: [IoInsightComponent],
  imports: [CommonModule, FormsModule, RouterModule, ButtonModule, InputTextModule, DropdownModule],
  exports: [IoInsightComponent],
})
export class IoInsightModule {}
